import * as types from '../types'
import { message } from 'antd'
// import update from 'immutability-helper'

const defaultState = {
  name: '默认值',
  route: '/order',
  tabsList: [
    {
      name: '首页',
      route: '/home',
      active: true
    }
  ]
}

/**
 * demo reducer
 * */
export default function tabs(state = defaultState, action = {}) {
  const { type, payload } = action
  const res = Object.assign({}, state)
  const data = [...state.tabsList]
  switch (type) {
    // 更新测试
    case types.UPDATE_NAME:
      res.name = payload.name
      break
    // 添加主页面tabs
    case types.ADD_TABSLIST:
      // 方法传过的值
      let obj = payload.obj
      // 本地json
      const addList = res.tabsList
      let bool = true
      let addIndex = 0
      // 获取localStorage值
      let getTabsLocalStorage = localStorage.getItem('tabsItem')
      
      if(obj && Array.isArray(obj)) {  // 保存tabs点击状态
        localStorage.setItem('tabsItem', JSON.stringify(obj))
        return Object.assign({}, state, { tabsList: obj })
        
      } else if(obj) {   // 保存添加状态
        for(let i=0,len=addList.length;i<len;i++) {
          addList[i].active = false
          for(let key in obj) {
            if(obj[key]==addList[i].name) {
              bool = false
              addIndex = i
              
            }
          }
        }
        if(bool) {
          data.push(obj)
          localStorage.setItem('tabsItem', JSON.stringify(data))
          return Object.assign({}, state, {tabsList: data})
        } else {
          data[addIndex].active = true
          localStorage.setItem('tabsItem', JSON.stringify(data))
          return Object.assign({}, state, {tabsList: data})
        }
      } else {  // 刷新页面读取状态
        
        if(getTabsLocalStorage) { 
          let arr = JSON.parse(getTabsLocalStorage)
          // let routeUrl = ''
          // 刷新显示之前的路由页面
          arr.forEach((item, i)=>{
            item.isMenu = false
          })
          localStorage.setItem('tabsItem', JSON.stringify([...arr]))
          return Object.assign({}, state, {tabsList: [...arr]})
        } else {
          let hasHome = false
          res.tabsList.forEach((item, i)=>{
            if(item.name=='首页') {
              hasHome = true
            }
          })
          if(!hasHome) {
            localStorage.setItem('tabsItem', JSON.stringify([...res.tabsList, {name: '首页', route: '/home', active: true, isRight: false}]))
          }
          //return Object.assign({}, state, {tabsList: [...res.tabsList, {name: '首页', route: '/home', active: true, isRight: false}]})
          return Object.assign({}, state, {tabsList: [...res.tabsList]})
        }
        
      }
      break
    // 删除主页面tabs
    case types.DEL_TABSLIST:
      localStorage.setItem('tabsItem', JSON.stringify(payload.list))
      return Object.assign({}, state, {tabsList: payload.list})
    default:

  }
  return res
}